import apiClient from './axios';

export async function fetchLoginEvents({
  days = 30,
  limit = 100,
  result = '',
  search = '',
} = {}) {
  const res = await apiClient.get('/v3/cs/login-event', {
    params: {
      days,
      limit,
      result: result || undefined,
      search: search?.trim() || undefined,
    },
  });

  return res.data;
}
